import { Offer } from "common/api/decimal/methods/compareAndPurchase";
import styles from "./OfferAction.module.scss";
import { useIntl } from "react-intl";
import clsx from "clsx";
import GlobalNavCart from "../../../../common/icons/GlobalNavCart.tsx";
import { useNavigate } from "react-router-dom";
import { useUpdateCartFetcher } from "../actions/updateCartAction.ts";
import LoaderButton from "common/core-ui/LoaderButton.tsx";

interface OfferItemProps extends Pick<Offer, "tempBookItemId"> {
  isPrimaryAction?: boolean;
  itemIsInCart: boolean;
  isbnIsInCart: boolean;
  price: string;
  retailer: string;
}

export default function OfferAction({
  itemIsInCart,
  isbnIsInCart,
  tempBookItemId,
  isPrimaryAction = true,
  price,
  retailer,
}: OfferItemProps) {
  const navigate = useNavigate();
  const intl = useIntl();
  const fetcher = useUpdateCartFetcher();
  const outlineButtonClass =
    !isPrimaryAction || itemIsInCart ? "vst-button-variant-outline" : null;
  const addToCart = () => {
    void fetcher.submit(
      {
        id: tempBookItemId,
      },
      {
        action: `/my-courses/update-cart`,
        method: "PUT",
      }
    );
  };
  const isLoading = fetcher.state === "submitting";
  const goToCart = () => {
    void navigate("/my-courses/my-cart");
  };

  const buttonText = () => {
    if (itemIsInCart) {
      return intl.formatMessage({ defaultMessage: "View in Cart" });
    } else if (isbnIsInCart) {
      return intl.formatMessage({ defaultMessage: "Swap" });
    } else {
      return intl.formatMessage({ defaultMessage: "Add to Cart" });
    }
  };

  const ariaLabel = () => {
    if (itemIsInCart) {
      return intl.formatMessage(
        { defaultMessage: "{buttonText}: {price} from {retailer}" },
        { buttonText: buttonText(), price, retailer }
      );
    } else if (isbnIsInCart) {
      return intl.formatMessage(
        {
          defaultMessage:
            "{buttonText} item: Add to cart for {price} from {retailer}",
        },
        { buttonText: buttonText(), price, retailer }
      );
    } else {
      return intl.formatMessage(
        { defaultMessage: "{buttonText}: {price} from {retailer}" },
        { buttonText: buttonText(), price, retailer }
      );
    }
  };

  return (
    <LoaderButton
      className={clsx(
        styles.action,
        "vst-button-size-small",
        "vst-button-pill",
        outlineButtonClass
      )}
      aria-label={ariaLabel()}
      loaderProps={{
        color: outlineButtonClass ? "thematic" : "white",
      }}
      loading={isLoading}
      onClick={() => (itemIsInCart ? goToCart() : addToCart())}
    >
      {itemIsInCart && <GlobalNavCart className={styles.cartImage} />}
      {buttonText()}
    </LoaderButton>
  );
}
